// extracted by mini-css-extract-plugin
export default {"status":"tag-status_status__MjzQ7","used":"tag-status_used__RlCFX","unused":"tag-status_unused__3Zv4t"};